import { ThrowableStatus } from "@wss/error-tracking/throwable";
import { CarouselItem } from "../Carousel/CarouselItem";

const fetchRelatedItemsAI = async (
  itemNumber: string,
  itemTitle: string,
  categoryId: string,
  categoryTitle: string,
  breadcrumbs: string[]
): Promise<ThrowableStatus<CarouselItem[]>> => {
  try {
    const response = await fetch("/api/relateditemsai", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        itemNumber,
        itemTitle,
        categoryId,
        categoryTitle,
        breadcrumbs,
      }),
    });

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }

    const carouselItems = await response.json<CarouselItem[]>();
    return { isError: false, value: carouselItems };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "There was an error with the '/api/relateditemsai' endpoint.",
        { cause: error }
      ),
    };
  }
};

export default fetchRelatedItemsAI;
